import styled from 'styled-components';

import { Wrapper as CounterWrapper } from '@spa/shared/components/Counter/styles';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${props => props.theme.space(2)};

  svg {
    margin-right: ${props => props.theme.space(2)};

    g {
      path {
        stroke: ${props => props.theme.colors.blueDianne};
      }
    }
  }

  ${CounterWrapper} {
    margin-left: ${props => props.theme.space(2)};
  }
`;
